"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPaymentIcon = void 0;
const getPaymentIcon = (code) => {
    const dict = {
        account: 'customer',
        cash: 'dollars',
        wirecard: 'credit-cards',
        ec_postfinance: 'post-finance',
        ec_bank: 'ec-card',
        datatrans: 'datatrans',
        transfer: 'transfer',
        payback: 'dollars', // TODO fix if need
    };
    return dict[code];
};
exports.getPaymentIcon = getPaymentIcon;
//# sourceMappingURL=getPaymentIcon.js.map